module.exports = __webpack_public_path__ + "img/over.453a9653.png";